export const blockIconsTransportationNoCrashNew = (
	<span className='material-symbols-outlined'>no_crash</span>
);
